import { Button, Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatDateWithoutTime } from '../../../utils/FormatUtils';
import PayableInvoiceItems from "../sections/PayableInvoiceItems";
import * as React from "react";
import { useEffect, useState } from "react";
import { usePayableInvoicesRepository } from "../../../api/repositories/PayableInvoicesRepository";
import PayableInvoiceTaxes from "../sections/PayableInvoiceTaxes";
import DownloadRoundedIcon from "@mui/icons-material/Download";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { ID_ACCOUNTED, ID_SENT, ID_UNACCOUNTED } from "../constants/PayableInvoicesStatuses";
import { useHasScope } from "../../../../../config/globalConfig";
import { DOWNLOAD_PAYABLE_PDF, DOWNLOAD_PAYABLE_XML } from "../../../utils/FinanceScope";

export interface PayableInvoiceDetailsProps {
    type?: string,
    invoice: any,
    invoiceParent?: any,
    originalInvoice?: any,
    preview: boolean,
    editable: boolean,
    setModifiedItems?: any,
    setError?: any,
    setSuccess?: any
}

const PayableInvoiceDetails = (props: PayableInvoiceDetailsProps) => {

    const { t } = useTranslation("finance", { keyPrefix: 'payable-invoices' });

    const navigate = useNavigate();
    const { downloadPDF, getMockMandatary, downloadXML } = usePayableInvoicesRepository();

    const type = props.type ? props.type : props.invoice.invoiceType;
    const [mandatary, setMandatary] = useState<any>({});

    const hasScope = useHasScope;

    useEffect(() => {
        setMandatary(getMockMandatary())
    }, []);

    return (
        <>
            <Card variant="outlined" sx={{ margin: '15px' }}>
                <CardContent>
                    <Grid container rowSpacing={4}>
                        <Grid item container columnSpacing={20} rowSpacing={4} sx={{ paddingLeft: "16px" }}>
                            <Grid item md={12}>
                                <Typography variant={'body1'} color={'neutral.dark'} fontWeight={700}>
                                    {t('preview.sections.title')}
                                </Typography>
                            </Grid>
                            {/*<Grid item md={6}>*/}
                            {/*    <Typography fontWeight={600} variant={'body1'}>*/}
                            {/*        {t('preview.sections.customer.title')}*/}
                            {/*    </Typography>*/}
                            {/*    <Typography fontWeight={400}>*/}
                            {/*        {props.invoice.customer.companyName ? props.invoice.customer.companyName : '-'}<br></br>*/}
                            {/*        {props.invoice.customer?.address + ' ' + props.invoice.customer?.houseNumber}<br></br>*/}
                            {/*        {props.invoice.customer?.zip + " " + props.invoice.customer?.city + " " + props.invoice.customer?.stateProvince + ' ' + props.invoice?.customer?.country}<br></br>*/}
                            {/*        {t("preview.sections.customer.tax-code")} {props.invoice.customer.taxCode ? props.invoice.customer.taxCode : ""}<br></br>*/}
                            {/*        {t("preview.sections.customer.vat-number")} {props.invoice.customer.vatCode ? props.invoice.customer.vatCode : ""}<br></br>*/}
                            {/*    </Typography>*/}
                            {/*</Grid>*/}
                            <Grid item md={6}>
                                <Typography fontWeight={600} variant={'body1'}>
                                    {t("preview.sections.mandatary.title")}
                                </Typography>
                                <Typography fontWeight={400}>
                                    {props.invoice.vendor.companyName ? props.invoice.vendor.companyName : ''}<br></br>
                                    {props.invoice.vendor.address ? props.invoice.vendor.address : ''}<br></br>
                                    {props.invoice.vendor.zip + " " + props.invoice.vendor?.city /*+ " " + props.invoice.vendor?.stateProvince + ' ' + props.invoice?.vendor?.country*/}<br></br>
                                    {t("preview.sections.mandatary.tax-code")} {props.invoice.vendor.taxCode ? props.invoice.vendor.taxCode : ''}<br></br>
                                    {props.invoice.vendor.vatCode ?  t("preview.sections.mandatary.vat-number") + " " + props.invoice.vendor.vatCode : ""}<br></br>
                                    {props.invoice.vendor.siren ? <>
                                                {t("preview.sections.mandatary.siren") + " " + props.invoice.vendor.siren}
                                                <br/>
                                                {t("preview.sections.mandatary.siret") + " " + props.invoice.vendor.siret}
                                            </>
                                            : ""
                                    }<br></br>
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item md={12}>
                            <Divider orientation={"horizontal"} variant={"middle"} />
                        </Grid>
                        <Grid item container rowSpacing={"32px"} columnSpacing={"15px"} sx={{ paddingLeft: "16px" }}>
                            <Grid item md={4}>
                                <Typography fontWeight={600} variant={'body1'}>
                                    {t("preview.sections.number")}
                                </Typography>
                                <Typography fontWeight={400} variant={'body1'}>
                                    {props.invoice?.sapInvoiceNumber ? props.invoice?.sapInvoiceNumber : props.invoice?.invoiceNumber}
                                </Typography>
                            </Grid>
                            <Grid item md={4}>
                                <Typography fontWeight={600} variant={'body1'}>
                                    {t("preview.sections.date")}
                                </Typography>
                                <Typography fontWeight={400} variant={'body1'}>
                                    {formatDateWithoutTime(props.invoice.invoiceDate)}
                                </Typography>
                            </Grid>
                            <Grid item md={4}>
                                <Typography fontWeight={600} variant={'body1'}>
                                    {t("preview.sections.due-date")}
                                </Typography>
                                <Typography fontWeight={400} variant={'body1'}>
                                    {formatDateWithoutTime(props.invoice.dueDate)}
                                </Typography>
                            </Grid>
                            <Grid item md={4}>
                                <Typography fontWeight={600} variant={'body1'}>
                                    {t("preview.sections.payment-method")}
                                </Typography>
                                <Typography fontWeight={400} variant={'body1'}>
                                    {props.invoice.paymentMethod.description ? props.invoice.paymentMethod.description : ''}
                                </Typography>
                            </Grid>
                            <Grid item md={4}>
                                <Typography fontWeight={600} variant={'body1'}>
                                    {t("preview.sections.currency")}
                                </Typography>
                                <Typography fontWeight={400} variant={'body1'}>
                                    {props.invoice.currency ? props.invoice.currency : "Eur"}
                                </Typography>
                            </Grid>
                            <Grid item md={4}>
                                <Typography fontWeight={600} variant={'body1'}>
                                    {t("preview.sections.invoice-schema")}
                                </Typography>
                                <Typography fontWeight={400} variant={'body1'}>
                                    {props.invoice.invoiceSchema.description}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item md={12}>
                            <Divider orientation={"horizontal"} variant={"middle"} />
                        </Grid>
                        <Grid item container>
                            <PayableInvoiceItems invoice={props.invoice} />
                        </Grid>
                        <Grid item md={12}>
                            <Divider orientation={"horizontal"} variant={"middle"} />
                        </Grid>
                        <Grid item md={12}>
                            <PayableInvoiceTaxes invoice={props.invoice} type={props.type} />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {!props.editable && !props.type && <Box style={{ display: 'flex', gap: '1ch', justifyContent: "flex-end" }}>
                {(props.invoice.status == ID_ACCOUNTED || props.invoice.status == ID_UNACCOUNTED || props.invoice.status == ID_SENT) && hasScope(DOWNLOAD_PAYABLE_XML) &&
                    <Button variant="outlined" color={'accent'} component="label" endIcon={<DownloadRoundedIcon />} onClick={() => {
                        downloadXML(props.invoice.id).then((res) => {
                            if (res?.result) {
                                const dataURI = 'data:application/xml;charset=utf-8;base64,' + encodeURI(res?.result);
                                const downloadLink = document.createElement('a');
                                downloadLink.href = dataURI;
                                downloadLink.download = "invoice" + props.invoice.id + ".xml";
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        });
                    }}>
                        {t("preview.buttons.download-xml")}
                    </Button>
                }
                {hasScope(DOWNLOAD_PAYABLE_PDF) && <Button variant="outlined" color={'accent'} component="label" endIcon={<DownloadRoundedIcon />}
                    onClick={() => {
                        downloadPDF(props.invoice.id).then((res) => {
                            if (res?.result) {
                                let pdfWindow = window.open("");
                                pdfWindow!.document.write(`<iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(res.result)}'/>`);
                            }
                        });
                    }}>
                    {t("preview.buttons.download")}
                </Button> }
            </Box>}
        </>
    )
}
export default PayableInvoiceDetails;